import React from 'react';

const LoadingState = ({ message = 'Loading...' }) => (
  <div className="fr-loading-state" style={{margin: "0 auto"}}>
    <div className="fr-spinner" />
    <span className="fr-loading-text">{message}</span>
  </div>
);

export default LoadingState;